import { render, staticRenderFns } from "./TagArticles.vue?vue&type=template&id=2f09996a&"
import script from "./TagArticles.vue?vue&type=script&lang=ts&"
export * from "./TagArticles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/home/vsts/work/1/a/NuxtApp/components/base/Icon.vue').default,BlogArticle: require('/home/vsts/work/1/a/NuxtApp/components/blog/Article.vue').default})
